import * as authSaga from './authSaga';
import * as menuSaga from './menuSaga';
import * as busquedasSaga from './busquedasSaga';
import * as formSaga from './formSaga';
import * as fuentesAbiertasSaga from './fuentesAbiertasSaga';
import * as reportSaga from './reportSaga';

import * as formBalisticaSaga from '../views/balistica/correlaciones/sagas/formSaga';
import * as graphBalisticaSaga from '../views/balistica/correlaciones/sagas/graphSaga';
import * as informeSaga from '../views/balistica/informes/sagas/informeSaga';

export function initSagas(sagaMiddleware) {
    Object.values(authSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
    Object.values(menuSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
    Object.values(busquedasSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
    Object.values(formSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
    Object.values(fuentesAbiertasSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
    Object.values(reportSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
    Object.values(formBalisticaSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
    Object.values(graphBalisticaSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
    Object.values(informeSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
}